import { createUseStyles } from "react-jss";

const useStyles = createUseStyles({
  messageCtn: {
    textAlign: "center",
    margin: "0 auto",
  },
});

export default useStyles;
